"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import { ExploreCityLink } from "./ExploreCityLink";

export function ExploreSubmarkets({ children = "", show = true }) {
  return show ? (
    <Block
      className={"explore_right"}
      id={"w-node-b35f597b-e6f8-10b1-5591-783698741553-98741553"}
      tag={"div"}
    >
      <Block className={"margin-bottom margin-small"} tag={"div"}>
        <Block className={"text-block-6"} tag={"div"}>
          {"Surrounding neighborhoods for you to explore:"}
        </Block>
      </Block>
      <Block className={"margin-bottom margin-small"} tag={"div"}>
        <Block className={"decoration-line is-grey"} tag={"div"} />
      </Block>
      <Block className={"explore_city-wrapper"} tag={"div"}>
        <Block className={"explore_city-list"} tag={"div"}>
          {children ?? (
            <>
              <ExploreCityLink cityNameText={"Scottsdale"} />
              <ExploreCityLink cityNameText={"Tempe"} />
              <ExploreCityLink cityNameText={"Chandler"} />
              <ExploreCityLink cityNameText={"North"} />
            </>
          )}
        </Block>
      </Block>
    </Block>
  ) : null;
}
